__turbopack_context__.v({
  "creditPanel": "credit-panel-module-scss-module__BdTaga__creditPanel",
  "creditPanelIconList": "credit-panel-module-scss-module__BdTaga__creditPanelIconList",
  "creditPanelIconWrap": "credit-panel-module-scss-module__BdTaga__creditPanelIconWrap",
});
